/**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */
export const removeBaseUrl = (url: string) => url.replace(/https?:\/\/[^/]+/, '');
